module.exports = __webpack_public_path__ + "img/whiteforwardarw.a6d8c494.svg";